<template>
  <div
    class="fixed inset-0 z-20 flex flex-col bg-white p-5 md:p-10"
    role="dialog"
  >
    <div
      class="container flex h-full flex-col overflow-y-auto text-xl md:text-2xl"
    >
      <header class="flex">
        <button @click="toggleShareModal" class="ml-auto">
          <span class="sr-only">{{ closeModalLabel }}</span>
          <svg
            width="38"
            height="38"
            focusable="false"
            aria-hidden="true"
            class="mr-3"
          >
            <use xlink:href="#close"></use>
          </svg>
        </button>
      </header>
      <div
        class="flex flex-auto flex-col items-center justify-center space-y-15"
      >
        <a
          class="inline-flex items-center"
          :href="`mailto:?subject=${title}&body=${encodeURIComponent(
            `${text} (${shareableLink})`
          )}`"
          target="_blank"
          rel="noopener"
        >
          <svg
            width="38"
            height="38"
            focusable="false"
            aria-hidden="true"
            class="mr-3"
          >
            <use xlink:href="#email"></use>
          </svg>
          {{ shareEmailLabel }}
        </a>
        <a
          class="inline-flex items-center"
          :href="`https://www.facebook.com/sharer.php?display=page&u=${shareableLink}`"
          target="_blank"
          rel="noopener"
        >
          <svg
            width="38"
            height="38"
            focusable="false"
            aria-hidden="true"
            class="mr-3"
          >
            <use xlink:href="#facebook"></use>
          </svg>
          {{ shareFacebookLabel }}
        </a>

        <button
          class="inline-flex items-center"
          @click="
            toggleShareModal();
            copyTextRaw(shareableLink, `${linkCopyTitle}`);
          "
        >
          <svg
            width="38"
            height="38"
            focusable="false"
            aria-hidden="true"
            class="mr-3"
          >
            <use xlink:href="#copy"></use>
          </svg>
          {{ copyLinkLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { copyTextRaw } from '../utils/clipboard';
import { link, linkAlias, text, title, toggleShareModal } from '../utils/share';

export default defineComponent({
  props: {
    closeModalLabel: { type: String, required: true },
    shareEmailLabel: { type: String, required: true },
    shareTwitterLabel: { type: String, required: true },
    shareFacebookLabel: { type: String, required: true },
    copyLinkLabel: { type: String, required: true },
    linkCopyTitle: { type: String, required: true },
  },

  setup() {
    const twitterParams = computed((): string => {
      const params: string[] = [];
      params.push(
        `text=${encodeURIComponent(
          `${text.value ? text.value : title.value} (${link.value})`
        )}`
      );

      return params.join('&');
    });

    /**
     * `linkAlias` is only available on object pages, not on my-album.
     * `shareableLink` falls back to `link` if `linkAlias` is not set.
     */
    const shareableLink = computed((): string => {
      return linkAlias.value || link.value;
    });

    return {
      toggleShareModal,
      copyTextRaw,
      shareableLink,
      title,
      text,
      twitterParams,
    };
  },
});
</script>
